import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  TypePatchOwnerSupplierManagerDeleteParams,
  TypePatchOwnerSupplierManagerDeleteResponse,
} from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 담당자 정보 삭제
 */
const usePatchOwnerSupplierManagerDelete = () => {
  const endPoint = '/api-owner/owner-supplier-manager/delete';

  const patchOwnerSupplierManagerDelete = async (params: TypePatchOwnerSupplierManagerDeleteParams) => {
    return axiosInstance
      .patch<TypePatchOwnerSupplierManagerDeleteResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchOwnerSupplierManagerDelete };
};

export default usePatchOwnerSupplierManagerDelete;
